import React, { useState, useEffect, createContext } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Contact from './views/contact';
import AddressBan from './views/addressban';
import ShipmentDetail from './views/shipment'
import FFnewcall from './views/ffnewcall/FFnewcall'
import FinderFileBatches from './views/findersfilesmanagement/FinderFileBatches'
import UnreadMail from './views/unreadmail'
import CallDispositionTypes from './views/calldispositiontypes/CallDispositionTypes'
import NotificationGraphsContainer from './views/notificationgraphs'
import ProductOfferTypes from './views/productoffertypes/ProductOfferTypes'
import { closePopup } from './interop.js';
import { useCookies } from 'react-cookie';
import ScheduleOverview from './views/scheduler/scheduleoverview'
import IPWhitelist from './views/ipwhitelist';
import CallLog from './views/calls'


export type GetHeadersOpts = {
  contentType?: string
}


export interface MainAppMethods {
  getHeaders: (opts?: GetHeadersOpts) => Headers
  onClose?: () => void
  args?: any
  apiBase?: string
}

export const UserContext = createContext({})

function App() {

  // just using this for refesh. Unfortately token in state can't be seen by callback functions? 
  const [haveToken, setHaveToken] = useState(false);
  const [embRoute, setEmbRoute] = useState(""); // embedded route. Provided by container page. 
  const [gotContainerArgs, setGotContainerArgs] = useState(false);
  const [apiBase, setApiBase] = useState<string>("");

  // generic args obtained from container... or dev menu. Usage depends on feature/page. 
  const [args, setArgs] = useState(
    {
      arg1: "",
      arg2: "",
      arg3: "",
      arg4: "",
      arg5: "",
      arg6: ""
    });

  // This isn't used right now, since the site is embedded in the token for the API to
  // know who it needs to communicate with. But we may still need this client side so 
  // i'll leave this in for now. 
  let url_string: string = window.location.href;
  let url: any = new URL(url_string);
  let site: any = url.searchParams.get("site");
  site = "test";
  sessionStorage.setItem("olxsite", site);  // needed for api calls.

  // lousy V4 compatibility... remove this when OLX is update
  let faIconClass = process.env.NODE_ENV !== "development" ? "fas fa-pencil-alt" : "fas fa-pencil-alt" // fa fa-pencil"
  //if (window.location.href.indexOf("demo") > 0 || window.location.href.indexOf("test") > 0) faIconClass = "fas fa-pencil-alt"
  sessionStorage.setItem("pencilimg", faIconClass)


  const [cookies] = useCookies(["AppSvcKey"]);

  // Dev Auth 
  useEffect(() => {
    if (!haveToken && apiBase) {
      doAuth();
    }
  }, [haveToken, apiBase]);

  // Get the arguments from the container... if they exists
  useEffect(() => {

    // get arguments from container too. 
    const arg1: any = (window.document.getElementById("reactarg1") as HTMLInputElement);
    const arg2: any = (window.document.getElementById("reactarg2") as HTMLInputElement);
    const arg3: any = (window.document.getElementById("reactarg3") as HTMLInputElement);
    const arg4: any = (window.document.getElementById("reactarg4") as HTMLInputElement);
    const arg5: any = (window.document.getElementById("reactarg5") as HTMLInputElement);
    const arg6: any = (window.document.getElementById("reactarg6") as HTMLInputElement);


    setArgs({
      ...args,
      arg1: arg1 ? arg1.value : "",
      arg2: arg2 ? arg2.value : "",
      arg3: arg3 ? arg3.value : "",
      arg4: arg4 ? arg4.value : "",
      arg5: arg5 ? arg5.value : "",
      arg6: arg6 ? arg6.value : "",
    });

    setGotContainerArgs(true);// only do this once
    // eslint-disable-next-line
  }, [gotContainerArgs]);

  // Get embedded app page "route" from container. 
  useEffect(() => {
    // get our route from the container 
    const cmd: any = window.document.getElementById("reactcmd");
    if (cmd) {
      // cmd was not empty... save the value and rerender
      setEmbRoute(cmd.value);
    }

  }, [embRoute])


  // get the base... if we don't already have it
  useEffect(() => {
    // window location will be the same as the OLX instance that is hosting this app (it is embedded).
    // Use the subdomain name to figure out where the should direct our API calls. 
    const prot = window.location.protocol === "http:" ? "http" : "https";
    let base = ""

    // For development, when this app is running in WebPack dev server. 
    // AppSvcs session to be running. 
    if (url_string.indexOf("localhost") > -1) base = "https://localhost:44371/api"

    // on local workstation, we usually want to connect to API published on local machine IIS 
    // For everyday use of local app when debugging is not needed. 
    else if (url_string.indexOf("test.orderlogix.com") > -1) base = prot + "://apidev.orderlogix.com/api"  // IIS hosted

    // on local workstation, in IISExpress running in a debugger. For API debugging only when this app is running in OLX. 
    else if (url_string.indexOf("testx.orderlogix.com") > -1) base = "http://localhost:44371/api"  // IISExpress hosted

    // on local workstation, when API hosted in local docker container running port 8080. 
    else if (url_string.indexOf("testd.orderlogix.com") > -1) base = prot + "://api.orderlogix.com:8080/api" // dev docker hosted.

    // on stage or rc site, use stage instance of API for backend. For feature release upadtes. 
    else if (url_string.indexOf("stage.orderlogix.com") > -1) base = prot + "://apistage.orderlogix.com/api" // stage site 
    else if (url_string.indexOf("rc.orderlogix.com") > -1) base = prot + "://apistage.orderlogix.com/api" // stage site 

    // on listentrust hosing, use custom urls for backend. 
    else if (url_string.indexOf("olx-dev.listentrust.com") > -1) base = prot + "://olx-apistage.listentrust.com/api" // stage site 
    else if (url_string.indexOf("olx.listentrust.com") > -1) base = prot + "://olx-api.listentrust.com/api" // stage site 

    // this is default for real production instances. API services will be hosted at api.orderlogix.com (or ordermanagement.com) in the cloud. 
    else if (url_string.indexOf("ordermanagement.com") > -1) base = prot + "://api.ordermanagement.com/api" // New env... Azure.
    else base = prot + "://api.orderlogix.com/api"  // Old env... IIS

    sessionStorage.setItem("apibase", base) // backward compatibility... not all screens are context aware yet.
    setApiBase(base);

  }, [apiBase]);


  function getHeaders(opts?: GetHeadersOpts) {

    var hdrs: Headers = new Headers();

    // set some defaults 
    hdrs.set("Content-Type", "application/json")

    // if options were provided... override 
    if (opts !== undefined) {
      if (opts.contentType !== undefined) hdrs.set("Content-Type", opts.contentType);
    }

    var token = sessionStorage.getItem("token")
    if (token !== "") {
      // Have we a token? pass it. 
      hdrs.set("Authorization", 'Bearer ' + token);
    }

    return hdrs;
  }


  function doAuth() {

    // production mode... get token from secure cookie       
    if (cookies.AppSvcKey) {
      console.log("AppSvcKey:", cookies.AppSvcKey);
      // we got the cookie already... from shared session
      sessionStorage.setItem("token", cookies.AppSvcKey);
      setHaveToken(true);
      return;
    }

    /* We actually will pass the auth in from OLX... where the user already signed in. But we
    can obtain a auth token from here too for testing */
    const apiBase = sessionStorage.getItem("apibase");
    var _url = `${apiBase}/auth/login`;

    var _data = {
      username: "olx_dev",
      password: "h23G%6hh$j",
      tenant: "default"
    }

    var hdrs: Headers = new Headers();
    hdrs.set("Content-Type", "application/json")

    fetch(_url,
      {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify(_data)
      })
      .then(response => response.text())
      .then((data: string) => {
        console.log("Dev-AppSvcKey:", cookies.AppSvcKey);
        sessionStorage.setItem("token", data);
        setHaveToken(true);
      });

  }

  // Close... used for popups. 
  function close() {
    closePopup();
  }

  var routeComponent = null;
  if (embRoute === "customercontact") routeComponent = <Contact />;
  else if (embRoute === "addressban") routeComponent = <AddressBan getHeaders={getHeaders} />
  else if (embRoute === "shipdetail") routeComponent = <ShipmentDetail getHeaders={getHeaders} />
  else if (embRoute === "ffnewcall") routeComponent = <FFnewcall getHeaders={getHeaders} onClose={close} args={args} />
  else if (embRoute === "finderfilebatches") routeComponent = <FinderFileBatches getHeaders={getHeaders} onClose={close} />
  else if (embRoute === "unreadmail") routeComponent = <UnreadMail getHeaders={getHeaders} onClose={close} />
  else if (embRoute === "schedoverview") routeComponent = <ScheduleOverview />
  else if (embRoute === "calldispositiontypes") routeComponent = <CallDispositionTypes getHeaders={getHeaders} onClose={close} />
  else if (embRoute === "productofferyypes") routeComponent = <ProductOfferTypes getHeaders={getHeaders} onClose={close} />
  else if (embRoute === "ipwhitelist") routeComponent = <IPWhitelist />
  else if (embRoute === "calllog") routeComponent = <CallLog /> 
  else if (embRoute === "notificationgraphs") routeComponent = <NotificationGraphsContainer getHeaders={getHeaders} onClose={close} />
  else routeComponent = process.env.NODE_ENV !== "development" ? <div>Embedded route not set.</div> :
    <div>
      {/* Dev menu... shown when no embedded route info available */}
      Dev Menu!<br />
      <br />
      Example CustID: 115454
      <br />
      Arg1:<input type="text" onBlur={(e) => setArgs({ ...args, arg1: e.target.value })} title="a1" /><br />
      Arg2:<input type="text" onBlur={(e) => setArgs({ ...args, arg2: e.target.value })} title="a2" /><br />
      Arg3:<input type="text" onBlur={(e) => setArgs({ ...args, arg3: e.target.value })} title="a3" /><br />
      Arg4:<input type="text" onBlur={(e) => setArgs({ ...args, arg4: e.target.value })} title="a4" /><br />
      Arg5:<input type="text" onBlur={(e) => setArgs({ ...args, arg5: e.target.value })} title="a5" /><br />
      Arg6:<input type="text" onBlur={(e) => setArgs({ ...args, arg6: e.target.value })} title="a6" /><br />

      <button onClick={(e) => setEmbRoute("customercontact")} >Contact</button>
      <button onClick={(e) => setEmbRoute("addressban")} >Address Ban</button>
      <button onClick={(e) => setEmbRoute("shipdetail")} >Shipment Detail</button>
      <button onClick={(e) => setEmbRoute("ffnewcall")}>FF New Call</button>
      <button onClick={(e) => setEmbRoute("finderfilebatches")}>FF Management UI</button>
      <button onClick={(e) => setEmbRoute("unreadmail")}>Unread mail</button>
      <button onClick={(e) => setEmbRoute("schedoverview")}>Sched Overview</button>
      <button onClick={(e) => setEmbRoute("calldispositiontypes")}>Call Disposition Types</button>
      <button onClick={(e) => setEmbRoute("productofferyypes")}>Product Offer Types</button>
      <button onClick={(e) => setEmbRoute("ipwhitelist")}>IP Whitelist</button>
      <button onClick={(e) => setEmbRoute("calllog")}>Call Log</button>
      <button onClick={(e) => setEmbRoute("calldispositiontypes")}>Call Disposition Types</button>
      <button onClick={(e) => setEmbRoute("notificationgraphs")}>Notification Graphs</button>
    </div>



  //-------------------------------- Return statements below this point --------------------------

  // NO Auth... well... no can do. If there is an auth in secure cookie we can get past this. 
  if (!haveToken) return <div>Obtaining auth</div>;

  // Data and functions we want accessible anywhere!
  const contextValue = {
    getHeaders: getHeaders,
    onClose: onclose,
    args: args,
    apiBase: apiBase
  } as MainAppMethods

  // A route set by the container... or by the 
  return <div>
    {process.env.NODE_ENV === "development" ? <div className="btn btn-primary" onClick={() => setEmbRoute("")}>Back To Top</div> : null}
    <UserContext.Provider value={contextValue}>
      {routeComponent}
    </UserContext.Provider>
  </div>;

}


export default App;
